<script>
  import { formatMoney, makeWebsiteRequest, withTax, ignore } from '../../Common/tools';
  import { onMount } from 'svelte';
  import { External, M } from '../../external';
  import Slider from '../../Common/Slider.svelte';
  import ConfirmAddon from './ConfirmAddon.svelte';
  import { disableAddon, LABELS } from './addons';
  import { fly } from 'svelte/transition';

  export let onChange = ignore, onCanceled = ignore, addon = null, subscription, showLimitsReachedMessage = false;

  let loading = true;
  let labels = LABELS;
  let initialValue = 0;
  let currency = subscription.currency;
  let taxRate = subscription.activeVatPercent;
  let confirming = false;
  let idx = 0;
  let addons = [];

  let onOptionChange = () => {
    addon = addons[idx];
  };

  let disable = async () => {
    let result = await disableAddon(addon);
    if (result) {
      onChange(result);
    }
  };

  onMount(() => {
    addons = External.Website.addons.filter(addon => addon.type === 'EMAIL_MARKETING');
    if (addon) { // we passed in a specific addon
      idx = Math.max(addons.findIndex(add => add.value === addon.value), 0);
      initialValue = addon.value;
    } else { // no addon? get the active one from the current subscription
      addon = subscription.addons.find(addon => addon.type === 'EMAIL_MARKETING');
      if (addon) {
        idx = Math.max(addons.findIndex(add => add.value === addon.value), 0);
        initialValue = addon.value;
      } else { // ok default to the first available one
        idx = 0;
        addon = addons[0];
      }
    }
    loading = false;
  });
</script>
{#if !loading}
  <div class="popup-widget-wrapper" style="overflow-x: hidden">
    <div class="col20 f-left t-left flex align-center flex-col">
      <h2 class="col20 f-left mt-15 t-center big-title-popup">{labels['EMAIL_MARKETING']?.title}</h2>
      {#if showLimitsReachedMessage}
        <h4 class="col20 f-left mt-15 t-center big-title-popup">{M.RESOURCE_LIMIT_REACHED}</h4>
      {/if}
      <div class="col12 f-left t-center mt-10 light-gray-text f-14-regular">{labels['EMAIL_MARKETING']?.description}</div>
    </div>

    {#if confirming}
      <div class="col20 f-left" in:fly={{x: '100%'}}>
        <ConfirmAddon {addon} {currency} value={addon.value} {taxRate}
                      on:cancel={() => confirming = false}
                      on:confirm={(event) => onChange(event.detail)} />
      </div>
    {:else}
      <div class="col20 f-left" in:fly|local={{x: '-100%'}}>
        <div class="price-tables-wrapper table-of-one style-1 layout-2 col20 f-left mt-15">

          <div class="price-table most-popular highlight-table">
            <div class="price-table-inner">

              <div class="col20 f-left mb-5 t-left f-14-regular">{labels['EMAIL_MARKETING']?.summary(addon.value)}</div>
              <Slider bind:value={idx} min={0} max={addons.length - 1} onChange={onOptionChange} showValue={false} clz="inline-ui-slider mb-0" />

              <h3 class="price-table-value monthly mt-15">
                {@html formatMoney(addon.monthlyPrice, currency, true, true)}<span class="price-table-period">/{M.MONTH}</span>
                {#if subscription.activeVatPercent}
                  <span class="col20 f-left mt-5 price-table-support-text">{M.TAX_PLUS}</span>
                {/if}
              </h3>
              <div class="price-table-description">
                <ul class="icon-list-wrapper">
                  <li class="icon-list-item">
                    <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48">
                      <path d="M378-222 130-470l68-68 180 180 383-383 68 68-451 451Z"></path>
                    </svg>
                    <span class="icon-list-name">+{External.WebPlatform.addThousandsSeparator(addon.value * 12)} {M.EMAILS_PER_MONTH}</span>
                  </li>
                  <li class="icon-list-item">
                    <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48">
                      <path d="M378-222 130-470l68-68 180 180 383-383 68 68-451 451Z"></path>
                    </svg>
                    <span class="icon-list-name">{M.UNLIMITED_FLOWS}</span>
                  </li>
                  <li class="icon-list-item">
                    <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48">
                      <path d="M378-222 130-470l68-68 180 180 383-383 68 68-451 451Z"></path>
                    </svg>
                    <span class="icon-list-name">{M.UNLIMITED_CAMPAIGNS}</span>
                  </li>
                </ul>
              </div>
              <div class="price-table-footer">
                {#if addon.value === initialValue}
                  <a class="price-table-button disabled">
                    {M.YOUR_CURRENT_LIMIT}
                  </a>
                {:else}
                  <a class="price-table-button" on:click={() => confirming = true}>
                    {addon.value > initialValue ? M.UPGRADE : M.CHANGE}
                    <svg xmlns="http://www.w3.org/2000/svg" class="price-table-arrow" height="48" viewBox="0 -960 960 960" width="48">
                      <path
                        d="m695.461-314.463-32.615-31.999 109.847-110.231H140.001v-45.383h633.692L663.462-611.923l31.614-31.999 164.923 164.537-164.538 164.922Z"></path>
                    </svg>
                  </a>
                {/if}
              </div>
            </div>
          </div>
        </div>
        {#if initialValue > 0}
          <a class="col20 f-left t-center text-link-hover mt-15" on:click={disable}>{M.REMOVE_ADDON}</a>
        {/if}
      </div>
    {/if}
  </div>
{/if}
